export default "__VITE_ASSET__YR6v$Vww__"